export default __webpack_public_path__ + "static/media/bg.4544e8b3.jpg";